import { Component, inject, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { InviteFormStrategy } from './invite-form.interface';
import { EmailChipsInputComponent } from '../../molecules/email-chips-input/email-chips-input.component';

@Component({
  selector: 'ocp-invite-form',
  templateUrl: './invite-form.component.html',
  styleUrls: ['./invite-form.component.scss'],
  imports: [
    HlmButtonImports,
    FormsModule,
    TranslatePipe,
    EmailChipsInputComponent,
    ThemedIconComponent,
  ],
})
export class InviteFormComponent {
  private readonly chips = viewChild.required(EmailChipsInputComponent);
  protected readonly dynamicDialogRef = inject<BrnDialogRef<{ emails: string[] }>>(BrnDialogRef, {
    optional: true,
  });
  protected readonly strategy = inject(InviteFormStrategy);

  readonly emails = signal<string[]>([]);

  protected onSubmit(): void {
    const chips = this.chips();
    if (!chips.canSubmit() || chips.hasInvalidContent()) return;
    this.dynamicDialogRef?.close({ emails: chips.validEmails() });
  }
}
